import { c as _c } from "react/compiler-runtime";
import { Link } from "react-router";
import { cn } from "@/lib/utils";
import logo from "@/logo.svg";

// OSMIX wordmark — the same SVG shipped by seller-web. The SVG already carries
// the full "OSMIX" lettering, so no separate text span. Links home.
// `tone="dark"` — логотип подвала (кадры «Подвал»): тот же знак 104×20 цветом
// #2E2E2E; `tone="light"` — белый знак шапки 125×24 над градиентом «Стань
// продавцом». Красим маской по SVG, чтобы не заводить второй файл логотипа.
export function Logo(t0) {
  const $ = _c(7);
  const {
    className,
    tone: t1
  } = t0;
  const tone = t1 === undefined ? "brand" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex w-fit items-center", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== tone) {
    t3 = tone !== "brand" ? <span aria-hidden="true" className={cn("block", tone === "dark" ? "h-5 w-[104px] bg-[#2E2E2E]" : "h-6 w-[125px] bg-white")} style={{
      maskImage: `url("${logo}")`,
      WebkitMaskImage: `url("${logo}")`,
      maskSize: "contain",
      WebkitMaskSize: "contain",
      maskRepeat: "no-repeat",
      WebkitMaskRepeat: "no-repeat"
    }} /> : <img src={logo} alt="OSMIX" className="h-6 w-auto" />;
    $[2] = tone;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Link to="/" aria-label="OSMIX" className={t2}>{t3}</Link>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}